<template>
  <div class="index">
    <a-banner></a-banner>
    <my-service></my-service>
    <service-process></service-process>
    <partner></partner>
    <program></program>
    <customer></customer>
    <!-- <contact-us></contact-us> -->
  </div>
</template>

<script>
  import aBanner from './index/banner/banner'
  import myService from './index/service/myservice'
  import serviceProcess from './index/service/serviceprocess'
  import partner from './index/partner/partner'
  import customer from './index/customer/customer'
  import program from './index/program/program'
  import contactUs from './index/contactUs/contactUs'
  export default {
    name: '',
    data () {
      return {
      }
    },
    methods: {

    },
    components: {
      aBanner,
      myService,
      serviceProcess,
      partner,
      program,
      customer,
      contactUs
    }
  }
</script>
<style scoped>

.index{
  position: relative;
  overflow: hidden;
}
</style>




// WEBPACK FOOTER //
// src/components/index.vue